import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'
import { push } from 'connected-react-router'
import { Header } from 'components/layout'
import { Title, Button } from 'components/misc'
import { logout } from 'redux/modules/auth'
import { getToken } from 'utils/token'
import config from 'config'
import { getCustomHomePageCode } from '../../../utils/cookies'

const enhance = compose(
  connect(
    ({ auth }) => ({
      user: auth.user
    }),
    {
      logout,
      push
    }
  )
)

class LogoutInactive extends Component {
  static propTypes = {
    logout: PropTypes.func,
    push: PropTypes.func,
    location: PropTypes.object,
    user: PropTypes.object
  }

  state = {
    orgCode: null
  }

  componentDidMount = () => {
    const { user } = this.props

    const storedCode = getCustomHomePageCode()

    if(storedCode){
      this.setState({
        orgCode: storedCode
      })
    }

    if (getToken(user)) {
      this.props.logout()
    }
  }

  render() {
    const { location } = this.props

    const url = this.state.orgCode ? `${config.publicPath}/${this.state.orgCode}` : `${config.publicPath}/`

    return (
      <div>
        <Header />
        <div className="container">
          <div style={{ paddingTop: 100 }} className="text--center">
            <Title
              h1
              intlKey={
                get(location, 'state.reasonIntlKey') ||
                  'moduleTitle.you_have_been_logged_out_due_to_inactivity'
              }
            >
              {get(location, 'state.reason') ||
                'You have been logged out due to inactivity'}
            </Title>
            <Button onClick={() => this.props.push(url)}>
              <FormattedMessage id="button.login" defaultMessage="Login" />
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default enhance(LogoutInactive)
